"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var damaged_1 = require("./damaged");
exports.DamagedService = damaged_1.DamagedService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/damaged/services/index.js
// module id = 389
// module chunks = 0